import { render } from "./ShippingAddressModal.vue?vue&type=template&id=31d40846&scoped=true"
import script from "./ShippingAddressModal.vue?vue&type=script&lang=js"
export * from "./ShippingAddressModal.vue?vue&type=script&lang=js"

import "./ShippingAddressModal.vue?vue&type=style&index=0&id=31d40846&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d40846"]])

export default __exports__